import { render, staticRenderFns } from "./ProjectCardNano.vue?vue&type=template&id=63e80230&scoped=true"
import script from "./ProjectCardNano.vue?vue&type=script&lang=js"
export * from "./ProjectCardNano.vue?vue&type=script&lang=js"
import style0 from "./ProjectCardNano.vue?vue&type=style&index=0&id=63e80230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e80230",
  null
  
)

export default component.exports